import React from 'react';
import type { Icon } from '@tabler/icons-react';
import styles from './toolbar.module.css';

interface ToolbarChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
  icon?: Icon;
}

/** Toggleable filter chip — boolean filters and status filters alike. */
export const ToolbarChip: React.FC<ToolbarChipProps> = ({
  label,
  active,
  onClick,
  icon: IconCmp,
}) => (
  <button
    type="button"
    className={`${styles.chip}${active ? ` ${styles.chipActive}` : ''}`}
    aria-pressed={active}
    onClick={onClick}
  >
    {IconCmp && <IconCmp size={14} stroke={1.5} />}
    {label}
  </button>
);
